@if (bannerUrl(); as url) {
  <div class="banner" (click)="bannerAction()">
    <div class="img-box img-shimmer">
      <img class="img" [lazyLoad]="url" alt="" (onStateChange)="onImageStateChange($event, url)">
    </div>
  </div>
}
